import { DateTime } from 'luxon';
import { Instance, types } from 'mobx-state-tree';

const NextScheduleLesson = types
	.model('NextScheduleLesson', {
		id: types.identifierNumber,
		name: types.maybeNull(types.optional(types.string, '')),
		schedule_program_id: types.maybeNull(types.number),
		schedule_id: types.maybeNull(types.number),
		lesson_id: types.maybeNull(types.number),
		teacher_id: types.maybeNull(types.number),
		start: types.maybeNull(types.string),
		type: types.maybeNull(types.string),
		duration: types.maybeNull(types.number),
		deadline: types.maybeNull(types.string),
		order_id: types.maybeNull(types.number),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get dateTime() {
			return DateTime.fromSQL(self.start);
		},
		get dateTimeStart() {
			return DateTime.fromSQL(self.start);
		},
		get dateTimeEnd() {
			return DateTime.fromSQL(self.start).plus({ minutes: self.duration });
		},
	}))
	.views((self) => ({
		get dateString() {
			return self.dateTime.toISODate();
		},
		get timeString() {
			return self.dateTimeStart.toLocaleString(DateTime.TIME_24_SIMPLE);
		},
		get timesString() {
			return `${self.dateTimeStart.toLocaleString(DateTime.TIME_24_SIMPLE)} - ${self.dateTimeEnd.toLocaleString(DateTime.TIME_24_SIMPLE)}`;
		},
	}));

export default NextScheduleLesson;

export interface INextScheduleLessonModel extends Instance<typeof NextScheduleLesson> {}
